<template lang="pug">
.student-card-coupon-module
  .title {{ title }}
  .cards
    template(v-if="!preparing&&(!info||info.length===0)")
      Empty
    template(v-else)
      CardCouponItem.card-item(
        v-for="(item, index) in list",
        :info="item",
        :key="index",
        @btn="clickBtn"
      )
  .more.flex-mid(v-if="!more && info && info.length > 3", @click="showMore")
    span 查看更多
    .common-arrow-down
</template>

<script>
import Empty from '@/components/empty';
import CardCouponItem from './card-coupon-item';

export default {
  components: {
    CardCouponItem,
    Empty,
  },
  props: {
    info: {
      type: Array,
      default: null,
    },
    title: {
      type: String,
      default: '模块',
    },
    preparing: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      more: false,
    };
  },
  computed: {
    list() {
      if (this.preparing) {
        return [{ shadow: true }, { shadow: true }, { shadow: true }];
      }
      if (this.info.length > 3 && !this.more) {
        return this.info.slice(0, 3);
      }
      return this.info || [];
    },
  },
  methods: {
    showMore() {
      this.$emit('more');
      this.more = true;
    },
    clickBtn(item) {
      this.$emit('btn', item);
    },
  },
};
</script>

<style lang="less" scoped>
.student-card-coupon-module {
  .title {
    margin-bottom: 0.16rem;
    font-size: 0.14rem;
    font-weight: 500;
    color: #242729;
  }

  .more {
    font-size: 0.12rem;
    margin-top: 0.16rem;
    color: #879099;

    .common-arrow-down {
      border-color: #879099;
    }
  }

  .card-item {
    &:not(:last-of-type) {
      margin-bottom: 0.16rem;
    }
  }
}
</style>
